import { FurnitureType } from "../lib/types";
import { cn } from "../lib/utils";
import { Armchair, Sofa, Blinds, Lock, Check } from "lucide-react";
import { Badge } from "./ui/badge";

interface FurnitureSelectorProps {
  furnitureTypes: FurnitureType[];
  selectedFurniture: FurnitureType | null;
  onSelect: (furniture: FurnitureType) => void;
}

const iconMap = {
  chair: Armchair,
  sofa: Sofa,
  curtains: Blinds,
};

export function FurnitureSelector({ furnitureTypes, selectedFurniture, onSelect }: FurnitureSelectorProps) {
  return (
    <div className="space-y-4">      
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        {furnitureTypes.map((furniture) => {
          const IconComponent = iconMap[furniture.id as keyof typeof iconMap] || Armchair;
          
          return (
            <div
              key={furniture.id}
              className={cn(
                "furniture-option py-3 sm:py-4",
                selectedFurniture?.id === furniture.id && "selected"
              )}
              onClick={() => onSelect(furniture)}
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 mb-2 sm:mb-3 flex items-center justify-center rounded-full bg-gray-100 relative">
                <IconComponent className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600" />
                {selectedFurniture?.id === furniture.id && (
                  <div className="absolute -top-1 -right-1 w-4 h-4 sm:w-5 sm:h-5 bg-primary rounded-full flex items-center justify-center">
                    <Check className="h-2 w-2 sm:h-3 sm:w-3 text-white" />
                  </div>
                )}
              </div>
              <h3 className="font-medium text-gray-900 mb-1 text-xs sm:text-sm">
                {furniture.name}
              </h3>
              <p className="text-xs text-gray-600 text-center mb-2 hidden sm:block">
                {furniture.description}
              </p>
              <div className="flex justify-center">
                <Badge variant="outline" className="text-xs">Available</Badge>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
} 